module.exports = __webpack_public_path__ + "img/szablc-cover.f7842252.png";